import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "fontWeight"];
import { useState } from 'react';
import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardSection } from 'foundations-components/transitional/components/Card';
import { Table, TableHead, TableRow, TableBody, TableHoverContent, SortTH } from 'foundations-components/transitional/components/Table';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import styled from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "TableExample__Wrapper"
})(["border-radius:", ";border:1px solid ", ";overflow:hidden;th{border-block-start:0px !important;}"], ({
  theme
}) => theme.borderRadius[0], ({
  theme
}) => theme.color['border-core-default']);
export default function TableExample() {
  const [state, setState] = useState({
    people: [{
      name: "Ol' Alice",
      age: 85000000,
      region: 'North',
      isExpanded: false,
      pets: [{
        name: 'Fluffy',
        type: 'cat',
        age: 5
      }, {
        name: 'Spot',
        type: 'dog',
        age: 3
      }]
    }, {
      name: "Ol' Bob",
      age: 32000000,
      region: 'South',
      isExpanded: false,
      pets: []
    }, {
      name: "Ol' Carol",
      age: 49000000,
      region: 'East',
      isExpanded: false,
      pets: []
    }, {
      name: "Ol' Sam",
      age: 9001,
      region: 'South',
      isExpanded: false,
      pets: []
    }, {
      name: "Ol' Ihor",
      age: 8999,
      region: 'East',
      isExpanded: false,
      pets: []
    }, {
      name: "Ol' Billybob",
      age: 8999,
      region: 'North',
      isExpanded: false,
      pets: []
    }],
    sortedBy: {
      name: 'none',
      age: 'none',
      region: 'none',
      pets: 'none'
    }
  });
  const ModifiedSortTH = _ref => {
    let {
        children,
        fontWeight = '600'
      } = _ref,
      sortTHProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/_jsx(SortTH, Object.assign({
      typography: "heading-25"
    }, sortTHProps, {
      children: /*#__PURE__*/_jsx("span", {
        style: {
          fontWeight
        },
        children: children
      })
    }));
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H4, {
      marginBlockEnd: "400",
      children: "Table"
    }), /*#__PURE__*/_jsx(Wrapper, {
      children: /*#__PURE__*/_jsxs(Table, {
        flush: true,
        bordered: false,
        hover: true
        // @ts-expect-error - color is not permitted type but we need to pass it to override the default text color token
        ,
        color: "text-core-default",
        children: [/*#__PURE__*/_jsx(TableHead, {
          sticky: false,
          children: /*#__PURE__*/_jsxs(TableRow, {
            cursor: "pointer",
            children: [/*#__PURE__*/_jsx(ModifiedSortTH, {
              alignSortIconRight: true,
              truncate: true,
              sort: state.sortedBy.name,
              onSortChange: ({
                target: {
                  value
                }
              }) => {
                const sortedBy = {
                  name: value !== null && value !== void 0 ? value : 'none',
                  age: 'none',
                  region: 'none',
                  pets: 'none'
                };
                const people = value === 'ascending' ? state.people.sort((a, b) => a.name < b.name ? -1 : 1) : state.people.sort((a, b) => b.name < a.name ? -1 : 1);
                setState(newState => Object.assign({}, newState, {
                  sortedBy,
                  people
                }));
              },
              children: "Name"
            }), /*#__PURE__*/_jsx(ModifiedSortTH, {
              alignSortIconRight: true,
              align: "left",
              truncate: false,
              sort: state.sortedBy.age,
              onSortChange: ({
                target: {
                  value
                }
              }) => {
                const sortedBy = {
                  name: 'none',
                  age: value !== null && value !== void 0 ? value : 'none',
                  region: 'none',
                  pets: 'none'
                };
                const people = value === 'ascending' ? state.people.sort((a, b) => a.age < b.age ? -1 : 1) : state.people.sort((a, b) => b.age < a.age ? -1 : 1);
                setState(newState => Object.assign({}, newState, {
                  sortedBy,
                  people
                }));
              },
              children: "Number of page views"
            }), /*#__PURE__*/_jsx(ModifiedSortTH, {
              alignSortIconRight: true,
              align: "left",
              truncate: true,
              sort: state.sortedBy.region,
              onSortChange: ({
                target: {
                  value
                }
              }) => {
                const sortedBy = {
                  name: 'none',
                  age: 'none',
                  region: value !== null && value !== void 0 ? value : 'none',
                  pets: 'none'
                };
                const people = value === 'ascending' ? state.people.sort((a, b) => a.region < b.region ? -1 : 1) : state.people.sort((a, b) => b.region < a.region ? -1 : 1);
                setState(newState => Object.assign({}, newState, {
                  sortedBy,
                  people
                }));
              },
              children: "Region"
            }), /*#__PURE__*/_jsx(ModifiedSortTH, {
              align: "left",
              truncate: true,
              sort: state.sortedBy.pets,
              onSortChange: ({
                target: {
                  value
                }
              }) => {
                const sortedBy = {
                  name: 'none',
                  age: 'none',
                  region: 'none',
                  pets: value !== null && value !== void 0 ? value : 'none'
                };
                const people = value === 'ascending' ? state.people.sort((a, b) => a.pets.length < b.pets.length ? -1 : 1) : state.people.sort((a, b) => b.pets.length < a.pets.length ? -1 : 1);
                setState(newState => Object.assign({}, newState, {
                  sortedBy,
                  people
                }));
              },
              children: "Pets"
            })]
          })
        }), /*#__PURE__*/_jsx(TableBody
        // @ts-expect-error - backgroundColor is not permitted type but we need to pass it to override the default background color token
        , {
          backgroundColor: "fill-surface-default",
          children: state.people.map(({
            name,
            age,
            region,
            pets,
            isExpanded
          }) => {
            return /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsxs(TableRow, {
                cursor: "pointer",
                children: [/*#__PURE__*/_jsxs("td", {
                  children: [name, /*#__PURE__*/_jsx(TableHoverContent, {
                    marginInlineStart: "500",
                    children: /*#__PURE__*/_jsx("span", {
                      children: /*#__PURE__*/_jsx(Button, {
                        responsive: false,
                        size: "extra-small",
                        use: "secondary",
                        children: "Send to mom"
                      })
                    })
                  })]
                }), /*#__PURE__*/_jsx("td", {
                  children: I18n.formatNumber(age)
                }), /*#__PURE__*/_jsx("td", {
                  children: region
                }), /*#__PURE__*/_jsx("td", {
                  children: pets.length > 0 && /*#__PURE__*/_jsxs(Button, {
                    onClick: () => setState(newState => Object.assign({}, newState, {
                      people: newState.people.map(person => person.name === name ? Object.assign({}, person, {
                        isExpanded: !person.isExpanded
                      }) : person)
                    })),
                    children: [pets.length, " ", isExpanded ? 'Collapse' : 'Expand']
                  })
                })]
              }, name), isExpanded && pets && pets.map(pet => /*#__PURE__*/_jsxs(TableRow, {
                children: [/*#__PURE__*/_jsx("td", {
                  children: pet.name
                }), /*#__PURE__*/_jsx("td", {
                  children: pet.age
                }), /*#__PURE__*/_jsx("td", {
                  children: "--"
                }), /*#__PURE__*/_jsx("td", {
                  children: pet.type
                })]
              }, `${name}-${pet.name}`))]
            });
          })
        })]
      })
    }), /*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsx(Paginator, {
        maxVisiblePageButtons: 5,
        onPageChange: ({
          target: {
            value
          }
        }) => console.log(`Go to page ${value}`),
        page: 2,
        pageCount: 20
      })
    })]
  });
}